var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "auth-container" }, [
    _c(
      "div",
      { staticClass: "center" },
      [
        _c("router-link", { attrs: { to: { name: "top" } } }, [
          _c("img", {
            staticClass: "logo",
            attrs: { src: require("@/assets/img/logo.png") },
          }),
        ]),
        _vm.writerType
          ? _c("cat-icon", {
              staticClass: "cat-icon",
              attrs: { writerType: _vm.writerType, clickable: false },
            })
          : _vm._e(),
      ],
      1
    ),
    _c("div", { staticClass: "auth-container__card" }, [_vm._t("default")], 2),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }